import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from '@mui/material/Button';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { doc, getDoc } from 'firebase/firestore';
import { useTranslation } from 'react-i18next';

import { getIssueImage } from '../../api/aws/s3';
import { companiesRef } from '../../api/firebase/firestore/company';
import {
  primarycolor,
  secondaryButtonnBackground
} from '../../constants/Colors';
import { screenType } from '../../constants/enum';
import { throwError } from '../../modules/error';

const styles = {
  buttons: {
    display: 'flex',
    marginTop: '16px'
  },
  cardSize: {
    '@media screen and (max-width:480px)': {
      width: '95%'
    },
    margin: '0 auto',
    position: 'relative',
    width: '95%'
  },
  copyButton: {
    color: primarycolor,
    marginLeft: '16px'
  },
  image: {
    height: '148px',
    width: '100%'
  },
  imageContent: {
    height: '100%',
    objectFit: 'cover',
    width: '100%'
  },
  name: {
    color: '#222'
  },
  secondaryButtonnBackground,
  text: {
    color: '#808A9F',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '140%',
    marginTop: '8px',
    width: '95%'
  },
  title: {
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: '3',
    display: '-webkit-box',
    fontSize: '18px',
    fontWeight: '700',
    height: '66px',
    lineHeight: '21px',
    marginTop: '8px',
    overflow: 'hidden'
  }
};

interface GivenListType {
  screen: number;
  image: string;
  clientId: string;
  name?: string;
  title: string;
  season: string;
  deadline: string;
  purpose?: string | null;
  issueId: string;
  clientCompanyId?: string;
}

const GivenListCard: React.FC<GivenListType> = (props: GivenListType) => {
  const {
    image,
    clientId,
    name,
    title,
    season,
    deadline,
    purpose,
    issueId,
    screen,
    clientCompanyId
  } = props;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [imageData, setImage] = useState<string>();
  const [clientName, setClientName] = useState<string | undefined>();

  useEffect(() => {
    void (async () => {
      try {
        const img = await getIssueImage(image);
        const companyRef = doc(companiesRef, clientId);
        const companySnap = await getDoc(companyRef);
        setClientName(companySnap.data()?.name as string);
        setImage(img);
      } catch (e) {
        throwError(e);
      }
    })();
  }, [image]);

  return (
    <>
      <Typography component="div" sx={styles.cardSize}>
        <Typography component="div" sx={styles.image}>
          <CardMedia
            component="img"
            image={imageData}
            sx={styles.imageContent}
          />
        </Typography>
        {screen === screenType.agent && (
          <Typography sx={[styles.text, styles.name]}>{clientName}</Typography>
        )}
        <Typography sx={[styles.text, styles.name]}>{name}</Typography>

        <Typography sx={styles.title}>{title}</Typography>

        <Typography sx={styles.text}>
          {t('given.season')}：{season}
        </Typography>

        <Typography sx={styles.text}>
          {t('given.deadline')}：{deadline}
        </Typography>

        <Typography sx={[styles.text, { height: '46px' }]}>
          {t('given.purpose')}：{purpose}
        </Typography>
        <Typography component="div" sx={styles.buttons}>
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => {
              if (screen === screenType.client) {
                navigate(`/client/mypage/issue/edit?type=edit&id=${issueId}`);
              } else if (screen === screenType.agent) {
                navigate(`/agent/mypage/issue/edit?type=edit&id=${issueId}`, {
                  state: { id: clientCompanyId }
                });
              }
            }}
          >
            {t('given.edit')}
          </Button>
          {screen === screenType.agent && (
            <Button
              variant="outlined"
              color="error"
              sx={[styles.secondaryButtonnBackground, styles.copyButton]}
              onClick={() => {
                navigate(
                  `/agent/mypage/issue/edit?type=copy&copyId=${issueId}`,
                  {
                    state: { id: clientCompanyId }
                  }
                );
              }}
            >
              {t('given.copy')}
            </Button>
          )}
        </Typography>
      </Typography>
    </>
  );
};

export default GivenListCard;
